import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import TransformSection from './components/TransformSection';
import GallerySection from './components/GallerySection';
import TestimonialsSection from './components/TestimonialsSection';
import AboutSection from './components/AboutSection';
import StaffSection from './components/StaffSection';
import BlogSection from './components/BlogSection';
import FAQSection from './components/FAQSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';
import ServicePage from './pages/ServicePage';
import BlogPost from './pages/BlogPost';
import SleepApneaQuiz from './pages/SleepApneaQuiz';
import SleepApneaTreatment from './pages/SleepApneaTreatment';
import CPAPComparison from './pages/CPAPComparison';
import CPAPIntolerant from './pages/CPAPIntolerant';
import LeadCapturePopup from './components/LeadCapturePopup';
import StickyContactBar from './components/StickyContactBar';
import SleepApneaSection from './components/SleepApneaSection';
import FloatingCTA from './components/FloatingCTA';
import QuizRetargetingBanner from './components/QuizRetargetingBanner';
import GoogleReviewsSection from './components/GoogleReviewsSection';

const HomePage = () => {
  return (
    <div className="min-h-screen">
      <Navbar />
      <HeroSection />
      <SleepApneaSection />
      <ServicesSection />
      <TransformSection />
      <GallerySection />
      <TestimonialsSection />
      <GoogleReviewsSection />
      <AboutSection />
      <StaffSection />
      <BlogSection />
      <FAQSection />
      <ContactSection />
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App font-sans">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/sleep-apnea-quiz" element={<SleepApneaQuiz />} />
          <Route path="/sleep-apnea-treatment" element={<SleepApneaTreatment />} />
          <Route path="/cpap-vs-oral-appliance" element={<CPAPComparison />} />
          <Route path="/cpap-intolerant" element={<CPAPIntolerant />} />
          <Route path="/:serviceSlug" element={<ServicePage />} />
        </Routes>
        <LeadCapturePopup />
        <StickyContactBar />
        <FloatingCTA />
        <QuizRetargetingBanner />
      </BrowserRouter>
    </div>
  );
}

export default App;
